
import { ReactNode } from 'react';
import { HomePrivate, HomePublic, LoginPublic, QuestionPrivate } from './ComponentSplit';
interface routeTypes { path: string, element: JSX.Element, icon?: ReactNode, label?: string }

export const MainStack = {
  dashboard: {
    path: '/dashboard/:schedule',
    element: <HomePrivate />,
  },
  question: {
    path: '/question/:schedule/:index',
    element: <QuestionPrivate />,
  },
}

export const PublicStack = {
  home: {
    path: '/:schedule',
    element: <HomePublic />
  },
  login: {
    path: '/login/:schedule',
    element: <LoginPublic />
  },
}


export const RoutePrivateList: routeTypes[] = [
  MainStack.dashboard,
  MainStack.question
]

export const RoutePublicList: routeTypes[] = [
  PublicStack.login,
  PublicStack.home
]